import * as React from "react";
import {Dialog as DesignSystemDialog} from "@octopusdeploy/design-system-components";

export type DialogSize = "small" | "medium" | "large";

const dialogSizeWidths: Record<DialogSize, "480px" | "600px" | "800px" | "1000px"> = {
    small: "600px",
    medium: "800px",
    large: "1000px",
};

interface DialogProps {
    open?: boolean;
    dialogWidth?: DialogSize;
    repositionOnUpdate?: boolean; // no-op: kept for call-site compatibility
    onRequestClose?: () => void;  // no-op: kept for call-site compatibility
    children?: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = props => {
    const dialogWidth = dialogSizeWidths[props.dialogWidth ?? "small"];
    return (
        <DesignSystemDialog open={props.open || false} dialogWidth={dialogWidth}>
            {props.open && props.children}
        </DesignSystemDialog>
    );
};

Dialog.displayName = "Dialog";

export default Dialog;
